<script>
import AMapLoader from '@amap/amap-jsapi-loader';
window._AMapSecurityConfig = {
	securityJsCode: '8e9c248f99df3ed6ea243177e37306d1', // 安全密钥
};

import { httpAction } from '@/api/manage';
import { convertTime } from '@/utils/util';
let AMap = null;
let mapInstance = null;
var markers = [];
var icon = null;
var infoWindow = null;
export default {
	name: '',
	props: {},
	components: {},
	mixins: [],
	data() {
		return {
			dataList: [],
			checkAll: false,
			checkedCities: [],
			isIndeterminate: false,
			map: null,
			AMap: null,
			dataSet: new Set(),
			dataListShow: true,
			deviceTab: [],
			deviceStatus: 2,
			tabShow: true,
			showAlert: false,
			alertMessage: '',
		};
	},
	methods: {
		// 初始化地图
		initMap() {
			if (mapInstance) return mapInstance;
			return AMapLoader.load({
				key: 'c98add164435e1dd4beff2d292a4fffb',
				version: '2.0',
				plugins: ['AMap.convertFrom'],
			})
				.then((aMap) => {
					AMap = aMap;
					mapInstance = new AMap.Map('container', {
						zoom: 13.4,
						center: [116.532645, 40.101266],
						mapStyle: 'amap://styles/66382f6340493a41e17e609d48df5b08',
						resizeEnable: true,
					});
					icon = new AMap.Icon({
						size: new AMap.Size(35, 42),
						image:
							'https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/garbageCar.png',
						imageSize: new AMap.Size(25, 30),
						// imageOffset: new AMap.Pixel(-95, -3),
					});
					this.getGps(true);
				})
				.catch((e) => {
					console.log(e);
				});
		},
		getGps(bool) {
			httpAction('/carDev/location/getCurrentPosition', {}, 'post').then(
				async (res) => {
					if (res.code !== 200) return this.$message.warning(res.msg);
					res.data.time = convertTime(new Date(res.data.time * 1000));
					var marker;
					marker = new AMap.Marker({
						position: new AMap.LngLat(res.data.longitude, res.data.latitude),
						// anchor: 'bottom-center',
						icon: icon,
						offset: new AMap.Pixel(-13, -30),
					});

					httpAction(
						'/tq/getGpsAddr',
						{ lat: res.data.latitude - 0, lon: res.data.longitude - 0 },
						'post'
					).then((result) => {
						if (bool) {
							infoWindow = new AMap.InfoWindow({
								anchor: 'top-center',
								offset: new AMap.Pixel(0, 0),
								content:
									`<div style="width: 350px; font-size: 12px; position: relative; overflow: hidden;">` +
									`<div style="display: flex; justify-content: space-between; padding: 5px 8px; background-color: #fbfbfb;">` +
									`
        <div><span>${result.data}&nbsp</span></div>` +
									`
      </div>` +
									`<div style="display: flex; justify-content: space-between; align-items: center; padding: 5px 8px;">` +
									`
        <div>` +
									`<div style="display: flex;"><div style="color: #666;">方位：</div><div style="color: #333;">${res.data.azimuth}</div></div>` +
									`<div style="display: flex;"><div style="color: #666;">速度：</div><div style="color: #333;">${res.data.velocity}</div></div>` +
									`<div style="display: flex;"><div style="color: #666;">时间：</div><div style="color: #333;">${
										res.data.time || '暂无'
									}</div></div>` +
									`</div>` +
									`<div><img style="width:120px;height:68px;" src="${res.data.frontPhoto}" alt=""></div>` +
									`</div>` +
									`<div style="padding: 0 8px;">` +
									`<span><img style="width: 10px; height: 10px;" src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/loaction.png" alt=""></span>` +
									`<span>${res.data.address}</span>` +
									`</div>` +
									`<div style="padding: 5px 8px; width: 80px;">` +
									`<span><img src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/locationImmediate.png" alt="" onclick="locationImmediate()"></span>` +
									`</div>` +
									`<div style="position:absolute; bottom: -20px; left: 50%; transform: translateX(-50%); width: 0;height: 0; border-top: 10px solid #fff; border-right: 10px solid transparent; border-bottom: 10px solid transparent;  border-left: 10px solid transparent; "></div>` +
									`</div>`,
							});

							infoWindow.open(mapInstance, [
								res.data.longitude,
								res.data.latitude,
							]);
							mapInstance.setCenter([res.data.longitude, res.data.latitude]);
						}

						marker.on('click', function () {
							markers.forEach((item) => {
								item.setzIndex(12);
							});
							marker.setzIndex(13);
							infoWindow = new AMap.InfoWindow({
								anchor: 'top-center',
								offset: new AMap.Pixel(0, 0),
								content:
									`<div style="width: 350px; font-size: 12px; position: relative; overflow: hidden;">` +
									`<div style="display: flex; justify-content: space-between; padding: 5px 8px; background-color: #fbfbfb;">` +
									`
        <div><span>${result.data}&nbsp</span></div>` +
									`
      </div>` +
									`<div style="display: flex; justify-content: space-between; align-items: center; padding: 5px 8px;">` +
									`
        <div>` +
									`<div style="display: flex;"><div style="color: #666;">方位：</div><div style="color: #333;">${res.data.azimuth}</div></div>` +
									`<div style="display: flex;"><div style="color: #666;">速度：</div><div style="color: #333;">${res.data.velocity}</div></div>` +
									`<div style="display: flex;"><div style="color: #666;">时间：</div><div style="color: #333;">${
										res.data.time || '暂无'
									}</div></div>` +
									`</div>` +
									`<div><img style="width:120px;height:68px;" src="${res.data.frontPhoto}" alt=""></div>` +
									`</div>` +
									`<div style="padding: 0 8px;">` +
									`<span><img style="width: 10px; height: 10px;" src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/loaction.png" alt=""></span>` +
									`<span>${res.data.address}</span>` +
									`</div>` +
									`<div style="padding: 5px 8px; width: 80px;">` +
									`<span><img src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/locationImmediate.png" alt="" onclick="locationImmediate()"></span>` +
									`</div>` +
									`<div style="position:absolute; bottom: -20px; left: 50%; transform: translateX(-50%); width: 0;height: 0; border-top: 10px solid #fff; border-right: 10px solid transparent; border-bottom: 10px solid transparent;  border-left: 10px solid transparent; "></div>` +
									`</div>`,
							});

							infoWindow.open(mapInstance, [
								res.data.longitude,
								res.data.latitude,
							]);
							mapInstance.setCenter([res.data.longitude, res.data.latitude]);
						});
						markers.push(marker);
						mapInstance.add(markers);
					});
				}
			);
		},
		locationImmediate() {
			httpAction('/carDev/location/updateCommand', {}, 'post').then((res) => {
				if (res.code !== 200) return this.$message.warning(res.msg);
				// this.$message.success('操作成功');
				this.executeAfter60Seconds(res.data.waitTime);
			});
		},
		executeAfter60Seconds(time) {
			this.showAlert = true;
			this.alertMessage = '开始倒计时';
			let secondsLeft = time;
			const intervalId = setInterval(() => {
				this.alertMessage = `${secondsLeft}秒后执行操作`;
				secondsLeft--;
				if (secondsLeft < 0) {
					clearInterval(intervalId);
					this.alertMessage = '执行操作';
					// 在这里执行你的操作
					setTimeout(() => {
						this.showAlert = false;
						this.getGps(true);
						this.$message.success('操作成功');
					}, 2000); // 假设操作需要2秒完成
				}
			}, 1000);
		},
	},
	watch: {},
	computed: {},
	created() {
		this.initMap();
	},
	mounted() {
		window.locationImmediate = this.locationImmediate;
	},
	beforeDestroy() {
		mapInstance && mapInstance.destroy();
		mapInstance = null;
	},
};
</script>
<template>
	<div class="map">
		<el-alert
			v-if="showAlert"
			:title="alertMessage"
			type="info"
			:closable="false"
			center
		></el-alert>
		<div id="container" class="map-container"></div>
	</div>
</template>
<style scoped lang="less">
.map-container {
	width: 100vw;
	height: 100vh;
	// margin-top: 20px;
}
/deep/.amap-marker-label {
	border: none;
}
</style>
